import { render, staticRenderFns } from "./WholesaleCatalogo.vue?vue&type=template&id=368e6a14&scoped=true&"
import script from "./WholesaleCatalogo.vue?vue&type=script&lang=js&"
export * from "./WholesaleCatalogo.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleCatalogo.vue?vue&type=style&index=0&id=368e6a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e6a14",
  null
  
)

export default component.exports